<template>
  <div class="topBox">
    <div class="topleft">
      <div class="cursor" @click="$route.path !='/index'? $router.push('/'):''">
        <img src="../assets/zskicon/home.png" alt class="img" />
        <div>首页</div>
      </div>
      <div class="cursor" @click="$router.push('/zsk')">
        <img src="../assets/zskicon/zsk.png" alt class="img" />
        <div>知识库</div>
      </div>
      <div class="cursor" @click="$router.push('/qtsoft')">
        <img src="../assets/zskicon/soft.png" alt class="img" />
        <div>下载中心</div>
      </div>
    </div>
    <div class="topright cursor">
      <!-- <a href="/admin/Wx/index" v-else class="login">登录</a> -->
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <div v-if="userInfo.user_id" @click="$router.push('/HtView')">{{userInfo.user_name}} 管理后台</div>
          <div v-else class="login">
            登录
            <i class="el-icon-arrow-down el-icon--right"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <a
                  href="https://open.work.weixin.qq.com/wwopen/sso/qrConnect?appid=ww16e5aa61e4c0f0df&agentid=1000032&redirect_uri=https://zsk.d11k.com/admin/Wx/login&state=STATE"
                >管理员授权</a>
              </el-dropdown-item>
              <el-dropdown-item command="b">代理商授权</el-dropdown-item>
            </el-dropdown-menu>
          </div>
        </span>
      </el-dropdown>
    </div>

    <el-dialog
      title
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
     
    >
      <div>
        <span v-html="img"></span>
        <span class="wenzi">请用微信扫一扫授权</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/public/api.js";
export default {
  name: "zyc",
  components: {},
  data() {
    return {
      userInfo: {},
      dialogVisible: false,
      img: "",
      dialogWidth: "18%"
    };
  },
  methods: {
    handleCommand(v) {
      if (v == "b") {
        this.dialogVisible = true;
        api({
          url: "/api/Article/getViewtoken" // 接口地址
        }).then(response => {
          // 请求成功时的处理逻辑
          this.img = response.img;
          var token = response.token;
          console.log(response, token);
          var timeer = setInterval(() => {
            api({
              url: "api/Article/getTokenInfo?token=" + token,
              data: {
                token: token
              } // 接口地址
            }).then(response => {
              console.log(response.status);
              this.status = response.status;
              if (response.status == 1) {
                clearInterval(timeer);
                window.location.reload();
              }
            });
          }, 3000);
        });
      }
    },
    handleResize() {
      if (window.innerWidth <= 992) {
        this.dialogWidth = "70%";
      } else {
        this.dialogWidth = "16%";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    api({
      url: "/admin/User/info"
    }).then(res => {
      console.log(res);
      this.userInfo = res;
    });
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }
};
</script>

<style scoped lang="less">
.login {
  color: #fff;
}
.topBox {
  background-color: #000;
  width: 100%;
  line-height: 5vh;
  display: flex;
  justify-content: space-between;
  color: #fff;
  position: sticky;
  top: 0;
  // border: 1px solid red

  .topleft {
    display: flex;
    position: relative;
    left: 15%;
    // border: 1px solid #f00;


    .cursor {
      margin-right: 40px;
      display: flex;
      align-items: center;
      .img {
        width: 23px;
        height: 23px;
        margin-right: 5px;
      }
    }
  }

  .topright {
    margin-right: 3%;
  }
}
.cursor:hover {
  cursor: pointer;
}

// 移动端
@media (max-width: 992px) {
  .topBox .topleft .cursor .img {
    display: none;
  }
}

.wenzi {
  color: red;
  display: flex;
  justify-content: center;
}
</style>